import {
  defaultFormatter,
  mmmDoCommaSpaceYYYY,
  yyyyMmDdHhMmSs,
} from './formatters';
import { convertToValidDate } from './utils';

const formatStringMap: { [key: string]: (inputDate: Date) => string } = {
  'MMM Do, YYYY': mmmDoCommaSpaceYYYY,
  'YYYY-MM-DD HH:mm:ss': yyyyMmDdHhMmSs,
};

export class DateFormatterClass {
  date: Date;
  constructor(date: string | Date) {
    if (date instanceof Date) this.date = date;
    const convertedDate = convertToValidDate(date);
    if (convertedDate instanceof Date) {
      this.date = convertedDate;
    } else {
      this.date = new Date();
    }
  }

  format(formatString: string) {
    const formatter = formatStringMap[formatString];
    if (formatter) return formatter(this.date);
    return defaultFormatter(this.date);
  }
}

export const DateFormatter = (date: string | Date) =>
  new DateFormatterClass(date);
